import { render, staticRenderFns } from "./projectTeam.vue?vue&type=template&id=1695c8b0&scoped=true"
import script from "./projectTeam.vue?vue&type=script&lang=js"
export * from "./projectTeam.vue?vue&type=script&lang=js"
import style0 from "./projectTeam.vue?vue&type=style&index=0&id=1695c8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1695c8b0",
  null
  
)

export default component.exports